export default [
  {
    text: 'Товары поставщика',
    name: 'customSupplierProducts',
    value: 1000
  }
]
